import { z } from 'zod';

import { normalizeURIComponent, TAIGA_PREFIX, ZodTaigaId } from '@Common/types/b2b/axa/common';

export const TaigaSavingPlanSubtypeValues = ['PILOTE', 'LIBRE'] as const;
export type TaigaSavingPlanSubtype = (typeof TaigaSavingPlanSubtypeValues)[number];
const subtypePattern = TaigaSavingPlanSubtypeValues.join('|');

const ZodTaigaSavingPlanIdRegex = z.string().regex(
  new RegExp(
    `^${TAIGA_PREFIX}_([a-zA-Z0-9%/]+)_(${subtypePattern})(?:_([\\p{L}\\p{N} -]|%[0-9A-Fa-f]{2})+)?$`,
    'u', // Unicode flag for French special chars
  ),
  { message: 'Invalid Taiga Saving Plan ID format' },
);

export const ZodTaigaSavingPlanId = ZodTaigaSavingPlanIdRegex.transform(
  (taigaSavingPlanId, ctx) => {
    try {
      return normalizeURIComponent(taigaSavingPlanId);
    } catch {
      ctx.addIssue({
        code: 'custom',
        message: `Invalid taiga saving plan ID: ${taigaSavingPlanId}`,
        fatal: true,
      });
      return z.NEVER;
    }
  },
).meta({ override: { type: 'string' } });
export type TaigaSavingPlanId = z.TypeOf<typeof ZodTaigaSavingPlanId>;

export const ZodTaigaSavingPlanIdPathParam = ZodTaigaSavingPlanIdRegex.transform(
  (taigaSavingPlanId) => {
    return decodeURIComponent(taigaSavingPlanId);
  },
).meta({ override: { type: 'string' } });

export type TaigaIdPathParm = z.TypeOf<typeof ZodTaigaSavingPlanIdPathParam>;

export const ZodTaigaTransactionPolicyId = ZodTaigaId;

export type TaigaTransactionsPolicyId = z.TypeOf<typeof ZodTaigaTransactionPolicyId>;
